/**
 * SEO Configuration
 *
 * Environment-aware base URL for SEO meta tags.
 */

export const SEO_CONFIG = {
  baseUrl: import.meta.env.VITE_BASE_URL || 'https://saqrskills.com',
  trailingSlash: false,
  siteName: 'Saqr Skills',
  defaultOgImage: '/og-default.png',
  defaultOgImageAr: '/og-default-ar.png',
  twitterHandle: '@saqracademy',
};
